import React from "react";
import "./About.css";
import aboutus from "../../Sliderimg/about-hero.jpg";
import Mission from "../../Sliderimg/about1.jpg";
import mission1 from "../../Sliderimg/about3.jpg";
import vision from "../../Sliderimg/about2.jpg";
import skill from "../../Sliderimg/about4.jpg";
import { Helmet } from "react-helmet-async";
import Banner from "../../Banner/Banner";

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>
          About KitKat Tech – Our Mission, Vision and Services
        </title>
        <meta
          name="description"
          content="Learn about KitKat Tech, a top software development and web services company in Coimbatore, delivering innovative solutions, training, and digital growth for businesses."
        />
        <meta
          name="keywords"
          content="Web development, IT company, Software company, Web services, IT services, Digital solutions, Software solutions"
        />
        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://kitkatsoftwaretechnologies.com/about-us" />
        {/* <!-- Hreflang Tags --> */}
        <link rel="alternate" hrefLang="en-US" href="https://kitkatsoftwaretechnologies.com/about-us" />
        <link rel="alternate" hrefLang="en-GB" href="https://kitkatsoftwaretechnologies.com/about-us" />
        <link rel="alternate" hrefLang="en-MY" href="https://kitkatsoftwaretechnologies.com/about-us" />
        <link rel="alternate" hrefLang="en-SG" href="https://kitkatsoftwaretechnologies.com/about-us" />
        <link rel="alternate" hrefLang="en-AE" href="https://kitkatsoftwaretechnologies.com/about-us" />
        <link rel="alternate" hrefLang="x-default" href="https://kitkatsoftwaretechnologies.com/about-us" />

      </Helmet>

     <Banner image={aboutus} alt="About Us" />

      <div className="content_lists">
        <div className="about_main_cont">
          <div className="about_cont_p">
            <h1 className="product_title">About KitKat Software Technologies – Our Story & Vision</h1>
            <p className="about_cont_para_style">
              At KitKat Software Technologies, we provide exceptional digital solutions customized to address the distinct requirements of businesses in diverse sectors.
            </p>
            <p className="about_cont_para_style">
              Our expertise includes Web Development, Application Development, Creative Design, Quality Assurance, Banking Services, and Billing Software solutions.
            </p>
            <p className="about_cont_para_style">
              We take time to understand each client’s specific requirements to ensure our solutions help them achieve their business goals. Our team specializes in building customized websites aligned with business objectives, offering seamless functionality and a user-friendly experience. We also provide ongoing maintenance and support services to keep your website updated and performing efficiently.
            </p>
            <p className="about_cont_para_style">
              KitKat Software Technologies is dedicated to providing dependable, effective, and future-ready solutions for companies of all sizes by adopting a customer-focused strategy and having a strong love for innovation.
            </p>
            <h1 id="who"> Our Approach</h1>
            <p className="about_cont_para_style">
              Customers frequently interact with your business for the first time through your website. That is why we design websites that are informative, visually appealing, and easy to navigate. A professionally developed website strengthens your brand credibility and enhances user experience, helping convert visitors into customers.

            </p>{" "}

            <p className="about_cont_para_style">
              Choosing the right technology is essential for long-term success. Whether you need to improve an existing system or build a new one, our experts provide solutions aligned with your business strategy and growth plans.
            </p>{" "}
            <h1 id="who">Client-Centric Development</h1>
            <p className="about_cont_para_style">
              We involve our clients at every stage of the development process. By clearly understanding your business goals, we ensure the final product meets your expectations. We follow modern development methodologies such as Agile, which promotes collaboration, flexibility, early delivery, and continuous improvement to adapt quickly to changing requirements
            </p>
            <h1 id="who">Who we are</h1>
            <p style={{ fontSize: "18px", textAlign: "center", marginTop: 10 }}>
              <strong>We create, design, and transform ideas into reality.</strong>
            </p>
            <p className="about_cont_para_style">
              Our clients become an integral part of our project execution process. This collaborative approach simplifies software development and ensures the final outcome aligns with client expectations.
            </p>
            <p className="about_cont_para_style">
              Depending on project needs, we adopt suitable development methodologies. Agile development enables better planning, continuous feedback, adaptive execution, and faster delivery, ensuring high-quality results and flexibility throughout the project lifecycle.
            </p>
            <div className="about_page_flex_cont flex_about_b">
              <div className="our_skill flex_about">
                <h2 className="title2" id="skill">
                  Our Skills
                </h2>
                <p className="about_cont_para_style">
                  KITKAT was established to deliver offshore software development services and operates as a 100% software export unit. We have successfully delivered medium and large-scale projects on time and within budget using our Offshore Delivery Model, supported by strong managerial and technical expertise. With over <b>10+ years of experience</b>, KITKAT has adapted to evolving technologies and understands the cross-cultural needs of region-specific customers.
                </p>
              </div>
              <div className="about_image">
                <img
                  src={Mission}
                  width="100%"
                  height="100%"
                  alt="Kitkat Mission"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="about_page_flex_cont flex_about_b">
              <div className="about_image1">
                <img
                  src={vision}
                  width="100%"
                  height="100%"
                  alt="Kitkat Vision"
                  style={{ objectFit: "cover" }}
                />
              </div>
              <div className="our_skill flex_about2">
                <h2 className="title2" id="vision">
                  Our Vision
                </h2>
                <p className="about_cont_para_style">
                  To be a leading information technology solutions and services provider by consistently fulfilling the needs of customers, partners, and employees. We aim to deliver efficient and effective services using the best resources available. Our offshore delivery model enables us to provide highly skilled professionals at competitive costs while meeting challenging timelines.
                </p>
              </div>
              <div className="about_img_media">
                <img
                  src={vision}
                  width="100%"
                  height="100%"
                  alt="Vision"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="about_page_flex_cont flex_about_b">
              <div className="our_skill flex_about">
                <h2 className="title2" id="mission">
                  Our Mission
                </h2>
                <p className="about_cont_para_style">
                  Our mission is to achieve our vision by delivering innovative, proactive, efficient, cost-effective, and high-quality solutions to clients worldwide. We are committed to maintaining transparency, integrity, and strong internal values in all interactions with employees, partners, and customers. Our methodology ensures strict adherence to proper documentation, quality control processes, and continuous client communication.
                </p>
              </div>
              <div className="about_image">
                <img
                  src={mission1}
                  width="100%"
                  height="100%"
                  alt="Mission"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="about_page_flex_cont flex_about_b">
              <div className="about_image1">
                <img
                  src={skill}
                  width="100%"
                  height="100%"
                  alt="Professional Skills"
                  style={{ objectFit: "cover" }}
                />
              </div>
              <div className="our_skill flex_about2">
                <h2 className="title2" id="offering">
                  Our Offerings
                </h2>
                <p className="about_cont_para_style">
                  We provide end-to-end solutions ranging from hardware to software, networking to live remote support, embedded systems to project assistance. We work meticulously to deliver best-in-class services tailored to customer needs.
                </p>
              </div>
              <div className="about_img_media">
                <img
                  src={skill}
                  width="100%"
                  height="100%"
                  alt="Professional Skills"
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AboutPage;
